exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._11tHWZDQQMkKW-M7e6VjbM{position:relative;min-height:60px}._11tHWZDQQMkKW-M7e6VjbM._1MBR2HDRUV2Dn-G1YDOP7F{min-height:auto;height:20px;overflow:hidden;-webkit-line-clamp:1;text-overflow:ellipsis;overflow:hidden;display:-webkit-box;-webkit-box-orient:vertical;word-wrap:break-word}\n", ""]);

// Exports
exports.locals = {
	"SingleLineEditor": "_11tHWZDQQMkKW-M7e6VjbM",
	"clamp": "_1MBR2HDRUV2Dn-G1YDOP7F"
};